import { Component, OnInit } from '@angular/core';
import { RoutesService } from 'src/app/services/routes.service';

@Component({
  selector: 'app-not-authorized',
  templateUrl: './not-authorized.html',
  styleUrls: ['./not-authorized.scss']
})
export class NotAuthorizedPage implements OnInit {
  public url: string;
  
  constructor(private routeService: RoutesService) { }

  ngOnInit(): void {
    this.url = this.routeService.getCurrentPath();
  }

}